import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';

import { SiteMasterListItemModel } from '../../models';
import {
  LoadGlobalSiteMasterList,
  ResetGlobalSiteMasterState,
} from '../actions';
import { GlobalSiteMasterSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class GlobalSiteMasterStoreService {
  private store = inject(Store);

  get siteMasterList(): Signal<SiteMasterListItemModel[]> {
    return this.store.selectSignal(GlobalSiteMasterSelectors.siteMasterList);
  }

  get siteNicknameBySiteId(): Signal<Map<number, string>> {
    return this.store.selectSignal(
      GlobalSiteMasterSelectors.siteNicknameBySiteId,
    );
  }

  get siteMasterLoadingError$(): Observable<string | null> {
    return this.store.select(GlobalSiteMasterSelectors.siteMasterLoadedError);
  }

  get siteMasterLoaded$(): Observable<boolean> {
    return this.store.select(GlobalSiteMasterSelectors.siteMasterLoaded);
  }

  @Dispatch()
  loadGlobalSiteMasterList = () => new LoadGlobalSiteMasterList();

  @Dispatch()
  resetSiteMasterState = () => new ResetGlobalSiteMasterState();
}
